<template>
    <div v-if="user && !user.is_admin" class="container pt-5">
        <admin-warning-box></admin-warning-box>
    </div>
    <section v-else class="section-container">

        <div class="container-overlap bg-gradient-primary text-center">
            <div class="text-white text-bold text-md" v-if="user && user.team_settings">
                <div v-if="!user.team_settings.logo_url || user.team_settings.logo_url == ''">{{ user.team_settings.name }}</div>
                <div v-else class="d-flex justify-content-center align-items-center">
                    <img :src="user.team_settings.logo_url" style="max-height: 48px" class="mr-2">
                    <span>{{ user.team_settings.name }}</span>
                </div>
            </div>
        </div>

        <div class="container container-md">
            <div class="row">
                <div class="col-2"></div>
                <div class="col-12 col-lg-8 cardbox">
                    <h5 class="cardbox-heading pb-0">Team Settings <a class="btn btn-sm btn-secondary float-right" @click="init_form()"><i class="ion-edit text-grey mr-2"></i> Edit</a></h5>
                    <div class="cardbox-body" v-if="user && user.team_settings">
                        <div v-if="form_error" class="alert alert-danger">{{ form_error }}</div>
						<!--<pre>{{ JSON.stringify(team, null, 2) }}</pre>-->
                        <form v-on:submit.prevent="submit_form">
						<table class="table mb-0 settings-table">
                            <tbody v-if="user && user.team_settings">
                                <tr>
                                    <th style="width: 40%">Team Name</th>
                                    <td>
                                        <span v-if="!edit_mode">{{ user.team_settings.name || "Not set" }}</span>
                                        <span v-else><input v-model="form_data.name" type="text" id="team_name_input" class="form-control form-control-sm"/></span>
                                    </td>
                                </tr>
                                <tr>
                                    <th>Website</th>
                                    <td>
                                        <span v-if="!edit_mode">{{ user.team_settings.url || "Not set" }}</span>
                                        <span v-else><input v-model="form_data.url" type="text" class="form-control form-control-sm"/></span>
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        <span v-if="edit_mode">New team logo</span>
                                        <span v-else>Logo</span>
                                    </th>
                                    <td>
                                        <profile-image-selector v-if="edit_mode" :avatar_changed="(avatar_url) => { form_data.logo_url = avatar_url }"></profile-image-selector>
                                        <span v-else>
                                            <img v-if="user.team_settings.logo_url" :src="user.team_settings.logo_url" style="max-width: 100px; max-height: 100px" />
                                            <i v-else>No logo</i>
                                        </span>
                                    </td>
                                </tr>
                                <tr>
                                    <th>Secure Shares <i class="ion-information-circled icon-lg ml-1" v-popover="'Mandatory password protection of shares'"></i></th>
                                    <td>
                                        <div v-if="!edit_mode" style="cursor: help" :title="user.team_settings.is_passwordless_share_allowed ? 'Team Members are allowed to create Shares without password protection' : 'Every Share is protected by a strong, auto-generated password.'">
                                            <div v-if="user.team_settings.is_passwordless_share_allowed" class="text-warning">
                                                No <i class="ion-unlocked ml-1"></i>
                                            </div>
                                            <div v-else class="text-success">
                                                Yes <i class="ion-locked ml-1"></i>
                                            </div>
                                        </div>
                                        <div v-else>
                                            <button class="btn btn-sm" type="button" :class="{'btn-outline-success': form_data.unsafe_shares, 'btn-success font-weight-bold': !form_data.unsafe_shares}" @click="form_data.unsafe_shares = false"><i class="ion-locked mr-2"></i>Yes</button>
                                            <button class="btn btn-sm ml-2" type="button" :class="{'btn-outline-warning': !form_data.unsafe_shares, 'btn-warning font-weight-bold': form_data.unsafe_shares}"  @click="form_data.unsafe_shares = true"><i class="ion-unlocked mr-2"></i>No</button>
                                            <div><small :class="{'text-success': !form_data.unsafe_shares, 'text-warning': form_data.unsafe_shares}">{{ form_data.unsafe_shares ? "Team Members are allowed to create Shares without password protection" : "Every Share is protected by a strong, auto-generated password." }}</small></div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>User Quota</th>
                                    <td v-if="!user.team_settings.max_user_number"><span class="badge badge-success p-2">Unlimited</span></td>
                                    <td v-else>{{ user.team_settings.actual_user_number }} of {{ user.team_settings.max_user_number }} used <small>({{ Math.round( (user.team_settings.actual_user_number / user.team_settings.max_user_number) * 100 ) }}%)</small></td>
                                </tr>
                                <tr>
                                    <th>Storage Quota</th>
                                    <td v-if="!user.team_settings.max_storage"><span class="badge badge-success p-2">Unlimited</span></td>
                                    <td v-else>{{ user.team_storage_used | format_bytes }} of {{ user.team_settings.max_storage | format_bytes }} used <small>({{ Math.round((user.team_storage_used / user.team_settings.max_storage) * 100) }}%)</small></td>
                                </tr>
								<tr>
                                    <th>E-mail Domain<i class="ion-information-circled icon-lg ml-1" v-popover="`When an email domain is set, anyone with an email address from this domain can join your Team and access all Team files.<br/><br/>New members will be required to prove owning the email address by clicking a link that we send when they register.`"></i></th>
                                    <td>
                                        <span v-if="!edit_mode">{{ user.team_settings.email_domain ? '@'+user.team_settings.email_domain : "Not set" }}</span>
                                        <div v-else class="input-group">
                                            <span class="input-group-text" id="email_domain_addon">@</span>
                                            <input v-model="form_data.email_domain" type="text" class="form-control form-control-sm" aria-describedby="email_domain_addon"/>
                                        </div>
                                    </td>
								</tr>
                                <tr v-if="edit_mode">
                                    <td colspan="2" class="text-center" style="border-top: none">
                                        <div v-if="!form_loading">
                                            <button class="btn btn-secondary mr-2" type="button" @click="edit_mode = false">Cancel</button>
                                            <button class="btn btn-info btn-gradient" type="submit">Save</button>
                                        </div>
                                        <i v-else class="ion-load-c spin"></i>
                                    </td>
                                </tr>
								<tr>
                                    <th>Invited Users<i class="ion-information-circled icon-lg ml-1" v-popover="`You can invite members to your Team by their email addresses.<br/><br/>If your set an email domain, you don't need to invite your colleagues who has email addresses from this domain.`"></i></th>
                                    <td>
										<span v-if="!additional_emails || additional_emails.length == 0">
                                            <p><i>No one is invited</i></p>
                                        </span>
										<div v-else>
                                            <table class="table table-sm invites_table mb-1">
                                                <thead>
                                                    <th>E-mail address</th>
                                                    <th>Status</th>
                                                    <!--<th></th>-->
                                                </thead>
                                                <tbody>
                                                <tr v-for="email in additional_emails" :key="JSON.stringify(email)" class="invite_row">
                                                    <td>{{ email.email }}</td>
                                                    <td>{{ email.used === true ? "Used" : (email.used === false ? "Pending" : "...") }}</td>
                                                    <!--
                                                    <td>
                                                        <i v-if="email.delete_loading" class="ion-load-c spin"></i>
                                                        <span v-else>
                                                            <span v-if="email.used === false"><a href="#" @click="delete_email(email)" title="Delete invite"><i class="text-muted ion-minus-circled pointer delete_icon"></i></a></span>
                                                        </span>
                                                    </td>
                                                    -->
                                                </tr>
                                                </tbody>
                                            </table>
										</div>

                                        <button class="btn btn-secondary btn-gradient" type="button" v-if="!additional_email_form.show" @click="init_additional_email_form()"><i class="ion-plus-round mr-2"/>Invite by email</button>
                                        <div v-else>
                                            <form v-on:submit.prevent="submit_additional_email_form">
                                                <div class="input-group">
                                                    <input type="email" id="additional_email_input" class="form-control" v-model="additional_email_form.email" placeholder="E-mail address" />
                                                </div>
                                                <div class="input-group mt-1 justify-content-end">
                                                    <button class="btn btn-secondary mr-1" type="button" @click="additional_email_form.show=false"><i class="ion-close-round mr-1"></i> Cancel</button>
                                                    <button class="btn btn-success btn-gradient" type="submit" :disabled="additional_email_form.loading"><i class="ion-paper-airplane mr-1"></i> Send invite <i v-if="additional_email_form.loading" class="ml-1 ion-load-c spin"></i></button>
                                                </div>
                                                <div v-if="additional_email_form.error" class="text-danger">{{ additional_email_form.error }}</div>
                                            </form>
                                        </div>

									</td>
                                </tr>

                            </tbody>

                        </table>
                        </form>
                    </div>
                    <div class="cardbox-body" v-else>
                        Loading <i class="ion-load-c spin"></i>
                    </div>
                </div>
            </div>
        </div>

        <div class="container container-xl" v-if="cloud_locations && cloud_locations.length > 0">
            <div class="d-flex align-items-center justify-content-start">
                <h3>Data Locations</h3>
                <span v-if="all_gdpr" class="badge badge-success ml-2">GDPR <i class="ion ion-checkmark-circled ml-1"></i></span>
            </div>
            <div class="text-gray-light">All your files are distributed across these {{ cloud_locations.length }} locations.</div>

            <div class="row mt-4">
                <div class="col-12 col-md-6 col-xl-4 mb-4" v-for="location in cloud_locations.filter(loc => loc.provider || loc.backend)" :key="location.bucket_id">
                    <div class="cardbox fh mx-3">
                        <div class="cardbox-body">
                            <div class="selected_backend pb-0">
                                <template v-if="location.provider">
                                    <p class="text-center mb-4">
                                        <img
                                            v-if="location.provider"
                                            class="cloud-logo"
                                            :src="Utils.cloud_provider_logo_src(location.provider.logo_path)"
                                        />
                                    </p>

                                    <div class="mt-4 text-bold mb-1">Cloud Platform</div>
                                    <div class="ml-3">{{ location.provider.service_name }}
                                        <a
                                            v-if="location.provider.cloud_platform_url != ''"
                                            :href="location.provider.cloud_platform_url"
                                            target="_BLANK"
                                            rel="noopener"
                                            class="btn btn-sm btn-secondary ml-1"
                                            role="button"
                                            title="Open platform website in a new tab"
                                        ><i class="ion-android-open"></i></a>
                                    </div>
                                </template>
                                <template v-if="location.backend">
                                    <div class="mt-4 text-bold mb-1">Location</div>
                                    <div class="ml-3 nowrap">
                                        <img 
                                            v-if="location.backend.countrycode && location.backend.countrycode != ''"
                                            :src="Utils.flag_img_src(location.backend.countrycode)" class="mr-1"/>
                                        {{ location.backend.name }}, {{ location.backend.country }}
                                    </div>

                                    <div class="mt-4 d-flex justify-content-center">
                                        <span v-if="location.backend.is_gdpr" class="badge badge-success mr-1 ml-1 p-2 text-bold" style="font-size: 80%;">GDPR</span>
                                    </div>
                                </template>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container" v-show="!hide_storage_history">
            <h3 class="mb-4">Storage Usage</h3>
            <div class="cardbox">
                <div class="cardbox-body">
                    <div class="flot-chart" id="spline-flotchart" style="height: 400px"></div>
                </div>
            </div>
        </div>

        <!--
        <div class="container container-lg">
            <h3>Team Event History <span class="badge badge-success text-sm">Preview</span></h3>
            <div class="row" v-if="events && user && user.team">
                <div v-for="event in events" :key="event.id" class="col-3">
                    <event-box :event="event" :team="user.team"></event-box>
                </div>

                <div class="col-3">
                    <div class="cardbox">
                        <div class="cardbox-body">
                            <div class="fw d-flex align-items-center justify-content-center">
                                <button class="btn btn-secondary mr-1" :disabled="events_offset === 0" @click="events_offset -= events_pagesize; load_events()">&lt; Back</button>
                                <button class="btn btn-secondary ml-1" :disabled="(events.length == 0) || (events.length % events_pagesize !== 0)" @click="events_offset += events_pagesize; load_events()">Next &gt;</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        -->

    </section>
</template>

<script>

import '@/assets/vendor/flot/jquery.flot.js'
import '@/assets/vendor/flot/jquery.flot.time.js'
import '@/assets/vendor/flot/jquery.flot.categories.js'
import '@/assets/vendor/flot-spline/js/jquery.flot.spline.js'
import '@/assets/vendor/flot.tooltip/js/jquery.flot.tooltip.js'
 
import { UserService } from '@/services/user-service.js'
import { FileVersionService } from '@/services/fileversion-service.js'
import { StorageBackendService, CloudProviderService, StorageLocationService } from '@/services/storage_backend-service.js'
import { Utils } from '@/helpers/utils.js'
import { bus, events } from '@/helpers/event_bus.js'

import adminWarningBox from '@/components/admin_feature_warning_box.vue'
//import eventBox from '@/components/event-box.vue'
import profileImageSelector from '@/components/profile-image-selector.vue'


const STORAGE_CHART_OPTIONS = {
    series: {
        lines: {
            show: false
        },
        points: {
            show: true,
            radius: 2
        },
        splines: {
            show: true,
            tension: 0.4,
            lineWidth: 2,
            fill: {}
        },
        
    },
    grid: {
        borderColor: 'rgba(162,162,162,.26)',
        borderWidth: 1,
        hoverable: true,
        backgroundColor: 'transparent'
    },
    tooltip: true,
    tooltipOpts: {
        content: (label, x, y) =>  Utils.format_bytes(y*1024*1024)
    },
    xaxis: {
        tickColor: 'rgba(162,162,162,.26)',
        font: {
            color: Utils.app_color_by_name('gray')
        },
        mode: 'time',
        timeformat: "%b %d"

    },
    yaxis: {
        min: 0,
        tickColor: 'rgba(162,162,162,.26)',
        font: {
            color: Utils.app_color_by_name('gray')
        },

        ticks: 3,
        tickFormatter: v => Utils.format_bytes(v*1024*1024)
    },
    shadowSize: 0
};

export default {

    props: ["user", "route"],

    components: {
        //eventBox,
        adminWarningBox,
        profileImageSelector
    },

    data() {
        return {

            additional_email_form: {
                show: false,
                email: "",
                loading: false,
                error: false
            },
           

            cloud_locations: null,

            hide_storage_history: false,

            edit_mode: false,
            form_data: null,
            form_error: false,
            form_loading: false,

            events: null,
            events_offset: 0,
            events_pagesize: 15,

            Utils: Utils
        }
    },

    computed: {
        additional_emails(){
            if(!this.user || !this.user.team || !this.user.team_settings ||  !this.user.team_settings.additional_email_addresses){ return [] }
            let result = []

            this.user.team_settings.additional_email_addresses.forEach(email => {
                const member = this.user.team.find( m => { return m.email_address == email } )
                result.push({
                    email: email,
                    used: (member !== undefined),
                    delete_loading: false
                })
            })
            return result
        },

        all_gdpr(){
            if(!this.cloud_locations) return false
            return !this.cloud_locations.find(c => !c.backend?.is_gdpr)
        }
    },

    created() {

        let buckets = []
        let backends = []
        let providers = []

        var self = this

        Promise.all([
            StorageBackendService.get_buckets().then(res => { buckets = res.body }),
            CloudProviderService.list().then(res => { providers = res.body }),
            StorageLocationService.list_my_team_locations().then(res => { backends = res.body }),
        ]).then(function(){
            self.cloud_locations = []
            buckets.forEach(bucket => {
                bucket.provider = providers.find(p => p.id === bucket.provider_code )
                bucket.backend = backends.find(b => b.id === bucket.backend_id )
                self.cloud_locations.push(bucket)
            })
        })

        const today = new Date()
        const start = Math.round(new Date().setDate(today.getDate() - 30)/1000)
        FileVersionService.get_storage_history(start).then(res => {
            let data = res.body
            if(!data || data.length === 0){
                // No storage history yet
                this.hide_storage_history = true
                return
            }

            let total_storage = []
            data.forEach(msmt => {
                const timestamp = msmt.timestamp*1000
                const total_storage_use = msmt.old_files
                total_storage.push([timestamp, Math.round(total_storage_use /(1024*1024))])
            })

           const _splineData = [
                {
                    label: "",
                    color: Utils.app_color_by_name('primary'),
                    data: total_storage,
                }
            ]
            $('#spline-flotchart').plot(_splineData, STORAGE_CHART_OPTIONS);
        })

    },

    methods: {

        init_additional_email_form: function(){
            this.additional_email_form = {
                show: true,
                email: "",
                loading: false,
                error: false
            },

            setTimeout(function(){
                document.getElementById("additional_email_input").focus()
            }, 200)
        },

        submit_additional_email_form: function(){
            const email_address = this.additional_email_form.email
            if(email_address == ""){ return; }

            this.additional_email_form.loading = true
            UserService.add_user_email(email_address).then(() => {
                bus.$emit(events.RELOAD_TEAM_SETTINGS)

                this.additional_email_form.show = false
                this.additional_email_form.loading = false

                Utils.show_success("Invite sent to " + email_address)
                /*
                this.additional_emails.push({
                    email: email_address,
                    used: false,
                    delete_loading: false
                })
                */
            }).catch(err => {
                this.additional_email_form.loading = false
                this.additional_email_form.error = err.body.message
                console.error(err)
            })
        },

        delete_email: function(){
            Utils.show_error("Invites cannot be deleted")
            return;
            /*

            email.delete_loading = true

            UserService.delete_user_email(email.email).then(res => {
                bus.$emit(events.RELOAD_TEAM_SETTINGS)
                email.delete_loading = false

                Utils.show_success("Invitation of "+email.email+" deleted.")
            }).catch(err => {
                email.delete_loading = false
                Utils.show_error("Error deleting invite of "+email.email + "! Please try deleting later.")
                console.error(err)
            })
            */
        },

        init_form(){
            this.form_data = {
                name: this.user.team_settings.name,
                url: this.user.team_settings.url,
                phone: this.user.team_settings.phone,
                unsafe_shares: this.user.team_settings.is_passwordless_share_allowed,
                email_domain: this.user.team_settings.email_domain,
                logo_url: this.user.team_settings.logo_url
            }

            this.form_error = false
            this.edit_mode = true

            setTimeout(function(){
                document.getElementById("team_name_input").focus()
            }, 200)
        },

        submit_form(){
            this.form_error = false

            if(this.form_data.name == ""){
                this.form_error = "Team name cannot be empty!"
                return
            }

            this.form_loading = true
            UserService.update_team_settings(this.form_data)
                .then(() => {
                    // OK
                    bus.$emit(events.RELOAD_TEAM_SETTINGS)

                    this.form_loading = false
                    this.edit_mode = false

                    Utils.show_success("Team settings changed successfully.")
                })
                .catch(err => {
                    this.form_loading = false
                    this.form_error = "Error saving team settings: " + err.body
                })
        },

        load_events(){
            return
            /*
            if(!this.user){
                return
            }

            const params = {
                limit_from: this.events_offset,
                howmany: this.events_pagesize
            }

            AuditLogService.query_events(params).then(res => {
                const events = res.body
                // console.log("Events: ", events)

                // Load connecting entities
                const ns_events = events.filter(e => { return e.entity_type == 3 || e.entity_type == 4 })
                const ns_entity_ids = ns_events.map(e => { return e.entity_id })
                this.events = events
                if(ns_entity_ids && ns_entity_ids.length >0){
                    NamespaceService.get_files_by_id(ns_entity_ids, true).then(res => {
                        const ns_entities = res.body

                        ns_events.forEach(e => {
                            const ns_file = ns_entities.find(file => { return file.id === e.entity_id })
                            if(!ns_file){ console.log("File/Folder #" + e.entity_id + " has been deleted")}

                            this.$set(e, 'file', ns_file)
                        })

                    })
                }

            }).catch(err => {
                console.error(err)
                Utils.show_error("Error loading event log: ", err.body.message)
            })
            */
        },

    },

}
</script>
<style lang="css" scoped>

.flot-chart{
    display: block;
    width: 100!;
    height: 475px;
    padding: 0px;
    position: relative;
}

.invites_table thead th{
    border-top: none;
    padding-top: 0px;
}

.selected-backend-box {
    margin: 2%;
    width: 29%;
    padding: 16px;
    min-height: 300px;
    margin-bottom: 24px;
}



.selected_backend .help-icon{
    font-size: 12pt;
    color: #ccc;
}
.selected_backend .help-icon:hover{
    color: inherit;
}

.settings-table th{
    text-align: right
}

.invites_table th{
    text-align: left
}

.invite_row:hover .delete_icon{
    color: #FF5252 !important
}

.cloud-logo{
    max-width: 150px; 
    max-height: 70px;
}

</style>
